var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.19 3 3.104 4.092 19.939 21l1.087-1.092-2.84-2.853c3.319-1.793 5.326-4.451 5.476-4.65l.003-.004.335-.455-.335-.463.013.007c-.19-.257-4.72-6.357-11.642-6.357h-.059c-1.729 0-3.306.382-4.706.96L4.191 3ZM8.47 7.296 9.48 8.313a4.383 4.383 0 0 1 2.555-.817c2.439 0 4.418 1.987 4.418 4.436 0 .959-.302 1.843-.813 2.567l1.392 1.398c2.499-1.25 4.283-3.105 5.021-3.958-1.157-1.36-4.936-5.261-10.024-5.261h-.06c-1.255 0-2.427.24-3.501.618Zm6.446 4.636a2.85 2.85 0 0 1-.391 1.445l-3.928-3.944c.423-.25.914-.392 1.44-.392 1.591 0 2.88 1.3 2.88 2.891Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.036 17.148c.605 0 1.19-.06 1.755-.159v.007l1.289 1.294c-.954.25-1.966.41-3.044.41h-.059C5.055 18.7.526 12.671.335 12.413L0 11.96l.335-.462c.105-.152 1.598-2.16 4.122-3.875L5.58 8.75a17.558 17.558 0 0 0-3.629 3.196c1.164 1.346 4.937 5.202 10.025 5.202h.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.036 16.375c.348 0 .69-.046 1.019-.125l-1.46-1.466a2.873 2.873 0 0 1-2.392-2.403l-1.46-1.465c-.078.33-.124.673-.124 1.023 0 2.45 1.978 4.443 4.417 4.443v-.007Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hide.cf85d2a8b16acf2bc2829677469cfa0b.svg";